import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import forIn from "lodash/forIn";

import Alert from "../../components/Alert";
import ButtonPrimary from "../../components/ButtonPrimary";
import ButtonText from "../../components/ButtonText";
import { useUserManager } from "../../services/auth";
import { resetPassword } from "../../config/router/routes";

import "./styles.scss";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const Error: FC = () => {
  const { t } = useTranslation();
  const userManager = useUserManager();
  const query = useQuery();
  const history = useHistory();

  const clearOIDC = async () => {
    try {
      await userManager.clearStaleState();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }

    try {
      await userManager.removeUser();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }

    forIn(window.localStorage, (value: string, key: string) => {
      if (key.startsWith("oidc.")) {
        window.localStorage.removeItem(key);
      }
    });

    forIn(window.sessionStorage, (value: string, key: string) => {
      if (key.startsWith("oidc.")) {
        window.sessionStorage.removeItem(key);
      }
    });
  };

  useEffect(() => {
    clearOIDC();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToLoginPage = async () => {
    userManager.signinRedirect();
  };

  const goToResetPassword = () => {
    history.push(resetPassword.path);
  };

  return (
    <div className="ams-error-page pa-l">
      <h1 className="mb-2xl">{t("loginHeader")}</h1>

      <Alert
        className="mb-2xl"
        variant="error"
        content={<div>{t(`error.${query.get("errorCode")}`)}</div>}
      />

      <ButtonPrimary className="mb-xl" size={"large"} onClick={goToLoginPage}>
        {t("login")}
      </ButtonPrimary>
      <div>
        <ButtonText onClick={goToResetPassword}>
          {t("forgotPassword")}
        </ButtonText>
      </div>
    </div>
  );
};
